export default __webpack_public_path__ + "static/media/docx.f4fd8d5f.svg";